import * as React from 'react';
import ContactCheckbox from './ContactCheckbox';

interface Props {
    preferenceValue?: number;
    setPreferenceValue: (preferenceValue: number) => void;
}

const ContactPreferencesCheckboxes = (props: Props) => {
    const emailChecked =
        !props.preferenceValue || props.preferenceValue === 2 || props.preferenceValue === 3;
    const phoneChecked =
        !props.preferenceValue || props.preferenceValue === 1 || props.preferenceValue === 3;

    const updatePreferences = (emailEnabled: boolean, phoneEnabled: boolean) => {
        if (emailEnabled && phoneEnabled) {
            props.setPreferenceValue(3);
        }

        if (!emailEnabled && phoneEnabled) {
            props.setPreferenceValue(1);
        }

        if (emailEnabled && !phoneEnabled) {
            props.setPreferenceValue(2);
        }
    };

    return (
        <section>
            How would you like to be contacted about tours?
            <ContactCheckbox
                labelText="Email"
                checked={emailChecked}
                onClick={() => updatePreferences(!emailChecked, phoneChecked)}
                rowClassname="contact-check-top-margin"
                opacity={phoneChecked ? 1 : 0.35}
            />
            <ContactCheckbox
                labelText="Text"
                checked={phoneChecked}
                onClick={() => updatePreferences(emailChecked, !phoneChecked)}
                rowClassname="contact-check-between-margin contact-check-bottom-margin"
                opacity={emailChecked ? 1 : 0.35}
            />
            <div style={{ display: "flex", flexDirection: "row", gap: '8px' }}>
                <p style={{ color: 'grey', fontSize: '12px', fontWeight: 'bold' }}>Note:</p>
                <p style={{ color: 'grey', fontSize: '12px' }}>By agreeing to SMS and email communications and scheduling a tour, you also allow the property and it's partners to contact you via both sms and email.</p>
            </div>
        </section>
    );
};

export default ContactPreferencesCheckboxes;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/account/ContactPreferencesCheckboxes.tsx